// Stage Mail-V2 Composer (2026-07-23): MailAttachmentsChips — shared attachment list.
//
// Purpose:
//   共享附件 chip 列表。被 MailV2ComposeDialog / MailV2InlineDraftEditor /
//   MailV2InlineReplyEditor 三个外壳共同使用。
//
// 设计:
//   - 受控组件(items / onRemove 由 caller 传入;caller 通常用 useAttachments hook)
//   - 不直接接 useAttachments,允许 caller 灵活选择数据源(Phase 4 Reply 已存在的附件)
//   - 与原 MailV2ComposeDialog.mv2-compose-attach-chips 视觉一致

import { Paperclip, X } from "lucide-react";
import type { MailAttachmentDTO } from "../../../api/mail-v2";

export interface MailAttachmentsChipsProps {
  items: MailAttachmentDTO[];
  onRemove?: (attachmentId: string) => void;
  disabled?: boolean;
}

function formatSize(bytes: number): string {
  if (!bytes || bytes <= 0) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

export function MailAttachmentsChips({
  items,
  onRemove,
  disabled = false,
}: MailAttachmentsChipsProps) {
  if (!items || items.length === 0) return null;

  return (
    <div
      className="mv2-compose-attach-chips"
      role="list"
      aria-label="添付ファイル一覧"
    >
      {items.map((a) => (
        <div
          key={a.id}
          className="mv2-compose-attach-chip"
          data-testid="mv2-compose-attach-chip"
          role="listitem"
        >
          <Paperclip size={12} />
          <span className="mv2-compose-attach-chip-name" title={a.filename}>
            {a.filename}
          </span>
          <span className="mv2-compose-attach-chip-size">
            ({formatSize(a.size_bytes)})
          </span>
          {onRemove && (
            <button
              type="button"
              className="mv2-compose-attach-chip-remove"
              onClick={() => onRemove(a.id)}
              disabled={disabled}
              aria-label={`${a.filename} を削除`}
              title="削除"
            >
              <X size={12} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}